export const SourcingOption = [
    { value: "external_purchase", label: "External Purchase" },
    { value: "internal_purchase", label: "Internal Purchase" },
    { value: "internal_manufactured", label: "Internal Manufactured" },
]

export const top = "top";
export const middle = "middle";
export const bottom = "bottom";

export const left = "left";
export const center = "center";
export const right = "right";

export const StaticContent = "StaticContent";
export const ImageContent = "ImageContent";
export const DynamicContent = "DynamicContent";

export const paperSizes = [
    { label: 'A0', value: 'A0' },
    { label: 'A1', value: 'A1' },
    { label: 'A2', value: 'A2' },
    { label: 'A3', value: 'A3' },
    { label: 'A4', value: 'A4' },
    { label: 'A5', value: 'A5' },
    { label: 'A6', value: 'A6' },  
    { label: 'Legal', value: 'LEGAL' },
    { label: 'Letter', value: 'LETTER' },
    { label: 'Tabloid', value: 'TABLOID' },
];

export const TypeOptions = [
    { label: "Fixed", value: "fixed" },
    { label: "Percentage", value: "percentage" },
];

export const DATE_TIME_WITH_ZONE_FORMAT = 'DD-MM-YYYY hh:mm A z';